<script setup lang="ts">
import { useAttrs } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import KTooltip from '@/components/tooltips/KTooltip.vue';

defineOptions({
  inheritAttrs: false,
});

const emit = defineEmits<{
  click: [];
}>();

const attrs = useAttrs();
</script>

<template>
  <span :class="$style.openJobEditIconLink" data-testid="openJobEditIconLink">
    <KTooltip location="top" :offset="0">
      <div>Edit job</div>
      <template #activator="{ props: tooltipProps }">
        <KBtn
          :active="false"
          v-bind="{ ...tooltipProps, ...attrs }"
          :class="$style.openJobEditIconLink"
          variant="text"
          size="xs"
          icon="mdi-pencil-outline"
          rounded="50"
          @click.stop="emit('click')"
        />
      </template>
    </KTooltip>
  </span>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.openJobEditIconLink {
}
</style>
